import { AxiosResponse } from 'axios';
import {
  call,
  CallEffect,
  ForkEffect,
  put,
  PutEffect,
  takeLatest,
} from 'redux-saga/effects';
import { $alerts } from '@pickit/pickit-components';
import i18next from '../../config/i18next';
import { actions } from '../../redux/forgotPassword/actions';
import * as ForgotPasswordService from '../../services/forgotPassword/forgotPassword';
import { ForgotPasswordResponseType } from '../../services/forgotPassword/types';

export function* forgotPassword(
  action: any,
): Generator<
  | CallEffect<AxiosResponse<ForgotPasswordResponseType>>
  | PutEffect<{ type: string }>
  | CallEffect<void>,
  void,
  ForgotPasswordResponseType
> {
  const response = yield call(
    ForgotPasswordService.forgotPassword,
    action.payload,
  );
  switch (response.status) {
    case 500:
      yield put(actions.getForgotPasswordError(false));
      return $alerts.next({
        type: 'error',
        title: i18next.t(`LoginService:errorCode${response.data.code}`),
        subMessage: i18next.t(
          `LoginService:errorCode${response.data.code}Body`,
        ),
        onConfirmLabel: i18next.t(`LoginService:errorModalButton`),
      });
    case 400:
      yield put(actions.getForgotPasswordError(true));
      return $alerts.next({
        type: 'error',
        title: i18next.t(`LoginService:errorCode${response.data.code}`),
        subMessage: i18next.t(
          `LoginService:errorCode${response.data.code}Body`,
        ),
        onConfirmLabel: i18next.t(`LoginService:errorModalButton`),
      });
    case 401:
      yield put(actions.getForgotPasswordError(true));
      return $alerts.next({
        type: 'error',
        title: i18next.t(`LoginService:errorCode${response.data.code}`),
        subMessage: i18next.t(
          `LoginService:errorCode${response.data.code}Body`,
        ),
        onConfirmLabel: i18next.t(`LoginService:errorModalButton`),
      });

    case 403:
      yield put(actions.getForgotPasswordError(true));
      return $alerts.next({
        type: 'error',
        title: i18next.t(`LoginService:errorCode${response.data.code}`),
        subMessage: i18next.t(
          `LoginService:errorCode${response.data.code}Body`,
        ),
        onConfirmLabel: i18next.t(`LoginService:errorModalButton`),
      });

    case 404:
      yield put(actions.getForgotPasswordError(true));
      return $alerts.next({
        type: 'error',
        title: i18next.t(`LoginService:errorCode${response.data.code}`),
        subMessage: i18next.t(
          `LoginService:errorCode${response.data.code}Body`,
        ),
        onConfirmLabel: i18next.t(`LoginService:errorModalButton`),
      });

    case 429:
      yield put(actions.getForgotPasswordError(true));
      return $alerts.next({
        type: 'error',
        title: i18next.t(`LoginService:errorCode${response.data.code}`),
        subMessage: i18next.t(
          `LoginService:errorCode${response.data.code}Body`,
        ),
        onConfirmLabel: i18next.t(`LoginService:errorModalButton`),
      });

    case 200:
      yield put(actions.getForgotPasswordSuccess(response.data));
      if (action.payload.onSuccess !== undefined) {
        action.payload.onSuccess(response.data);
      }
      return $alerts.next({
        type: action.payload.modalInfo ? 'info' : 'success',
        title: action.payload.modalInfo
          ? i18next.t('LoginService:successInfoMailSentTitle')
          : i18next.t('LoginService:successMailSentTitle'),
        subMessage: action.payload.modalInfo
          ? i18next.t('LoginService:successInfoMailSentBody')
          : i18next.t('LoginService:successMailSentBody'),
        onConfirmLabel: i18next.t(`LoginService:successModalButton`),
      });
    case 201:
      yield put(actions.getForgotPasswordSuccess(response.data));
      if (action.payload.onSuccess !== undefined) {
        action.payload.onSuccess(response.data);
      }
      return $alerts.next({
        type: action.payload.modalInfo ? 'info' : 'success',
        title: action.payload.modalInfo
          ? i18next.t('LoginService:successInfoMailSentTitle')
          : i18next.t('LoginService:successMailSentTitle'),
        subMessage: action.payload.modalInfo
          ? i18next.t('LoginService:successInfoMailSentBody')
          : i18next.t('LoginService:successMailSentBody'),
        onConfirmLabel: i18next.t(`LoginService:successModalButton`),
      });
    default:
      yield put(actions.getForgotPasswordError(true));
      return $alerts.next({
        type: 'error',
        title: i18next.t('LoginService:errorGeneralTitle'),
        subMessage: i18next.t('LoginService:errorGeneralBody'),
        onConfirmLabel: i18next.t(`LoginService:errorModalButton`),
      });
  }
}
const sagas: ForkEffect<never>[] = [
  takeLatest(actions.getForgotPasswordRequest.type, forgotPassword),
];

export default sagas;
